export default __webpack_public_path__ + "roboto-medium-webfont.woff";